import { Container, createStyles, Space, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

const useStyles = createStyles((theme) => ({
  list: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.md,
  },
}));

const welcome = {
  presentation:
    "Te presentamos ELSA, una herramienta digital que construye espacios laborales sin acoso. ELSA ha sido financiada por el Banco Interamericano de Desarrollo (BID), desarrollada por GenderLab e implementada con el apoyo del gobierno, los gremios empresariales y tu empleador.",
  nextSteps:
    "Agradecemos tu participación en esta encuesta y queremos comentarte algunas cosas para que puedas continuar.",
  purpose: "Propósito de la encuesta",
  objective:
    "El objetivo de esta encuesta es hacer un diagnóstico organizacional que nos permita recoger información básica sobre la organización, como el balance de género en la organización, políticas que tienen implementadas, los canales de apoyo en casos de acoso, las capacitaciones que dictan a diferentes grupos en la organización así como su contenido y metodología.",
  information:
    "Con toda la información recogida más la información agregada de las personas que trabajan en tu organización se elaborará un informe de resultados confidencial que te permitirá adoptar las mejores medidas para impulsar una cultura de prevención del acoso y violencia en el trabajo.",
  research:
    "Adicionalmente, las respuestas agregadas de todas las organizaciones serán utilizadas para realizar informes por sectores económicos y países. Esta información podrá ser también utilizada para realizar investigaciones y publicaciones académicas sobre cómo crear espacios laborales sin acoso.",
};

export const SurveyWelcome1 = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <Container fluid>
      <Title>{t("hello")}</Title>
      <Space h="md" />
      <Text ta="justify">{welcome.presentation}</Text>
      <Space h="md" />
      <Text>{welcome.nextSteps}</Text>
      <Space h="md" />
      <Text fw={700}>{welcome.purpose}</Text>
      <ul className={classes.list}>
        <li>
          <Text ta="justify">{welcome.objective}</Text>
        </li>
        <li>
          <Text ta="justify">{welcome.information}</Text>
        </li>
        <li>
          <Text ta="justify">{welcome.research}</Text>
        </li>
      </ul>
    </Container>
  );
};
